import 'viewerjs/dist/viewer.css';
import '@/style.less';

import CKEditor from '@ckeditor/ckeditor5-vue';
import {
  Alert,
  Avatar,
  Badge,
  Breadcrumb,
  Button,
  Card,
  Cascader,
  Checkbox,
  Col,
  Collapse,
  ConfigProvider,
  DatePicker,
  Descriptions,
  Divider,
  Dropdown,
  FormModel,
  Icon,
  Input,
  InputNumber,
  Layout,
  List,
  Menu,
  message,
  Modal,
  Popconfirm,
  Radio,
  Row,
  Select,
  Skeleton,
  Space,
  Statistic,
  Switch,
  Table,
  Tabs,
  Tooltip,
  Tree,
  Upload,
} from 'ant-design-vue';
import Viewer from 'v-viewer';
import Vue from 'vue';

import App from '@/App.vue';
import MainContainer from '@/components/layout/MainContainer';
import router, { routeName } from '@/router';
import store from '@/store';

import html2PDF from './components/pdf/pdf.js';
//引入拖拽排序插件
import VueDND from 'awe-dnd';

Vue.config.productionTip = false;
Vue.prototype.$routeName = routeName;
Vue.prototype.$message = message;

Vue.use(VueDND);
Vue.use(Viewer);
Vue.use(Modal);
Vue.use(FormModel);
Vue.use(CKEditor);
Vue.use(html2PDF);

Vue.component(ConfigProvider.name, ConfigProvider);
Vue.component(Button.name, Button);
Vue.component(Space.name, Space);
Vue.component(Badge.name, Badge);
Vue.component('a-button-group', Button.Group);
Vue.component(Alert.name, Alert);
Vue.component(Input.name, Input);
Vue.component(Input.Password.name, Input.Password);
Vue.component(Input.TextArea.name, Input.TextArea);
Vue.component(InputNumber.name, InputNumber);
Vue.component(Upload.name, Upload);
Vue.component(Radio.name, Radio);
Vue.component(Radio.Group.name, Radio.Group);
Vue.component(Radio.Button.name, Radio.Button);
Vue.component(Select.name, Select);
Vue.component(Select.Option.name, Select.Option);
Vue.component(Switch.name, Switch);
Vue.component(Checkbox.Group.name, Checkbox.Group);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Cascader.name, Cascader);
Vue.component(Tree.name, Tree);
Vue.component(DatePicker.name, DatePicker);
Vue.component(DatePicker.RangePicker.name, DatePicker.RangePicker);
Vue.component(Icon.name, Icon);
Vue.component('a-layout', Layout);
Vue.component(Layout.Sider.name, Layout.Sider);
Vue.component('a-layout-header', Layout.Header);
Vue.component('a-layout-content', Layout.Content);
Vue.component('a-layout-footer', Layout.Footer);
Vue.component(Menu.name, Menu);
Vue.component('a-menu-item', Menu.Item);
Vue.component('a-menu-divider', Menu.Divider);
Vue.component(Menu.SubMenu.name, Menu.SubMenu);
Vue.component(Breadcrumb.name, Breadcrumb);
Vue.component(Breadcrumb.Item.name, Breadcrumb.Item);
Vue.component(Card.name, Card);
Vue.component(Table.name, Table);
Vue.component(Tooltip.name, Tooltip);
Vue.component(Divider.name, Divider);
Vue.component(Popconfirm.name, Popconfirm);
Vue.component(Tabs.name, Tabs);
Vue.component(Tabs.TabPane.name, Tabs.TabPane);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Descriptions.name, Descriptions);
Vue.component('a-descriptions-item', Descriptions.Item);
Vue.component(Avatar.name, Avatar);
Vue.component(Dropdown.name, Dropdown);
Vue.component(Statistic.name, Statistic);
Vue.component(Collapse.name, Collapse);
Vue.component(Collapse.Panel.name, Collapse.Panel);
Vue.component(List.name, List);
Vue.component(List.Item.name, List.Item);
Vue.component(Skeleton.name, Skeleton);

Vue.component(MainContainer.name, MainContainer);

export default new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
